export * from "-!../../../developer-tools/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../developer-tools/node_modules/pug-plain-loader/index.js!./popup.pug?vue&type=template&id=2d0cb72a&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ../source/common/popup/popup.pug?vue&type=template&id=2d0cb72a&lang=pug&
// module id = 240
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 16 17 18